var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-btn",class:_vm.buttonClass,on:{"click":_vm.goBack}},[_vm._v("Voltar")])
}
var staticRenderFns = []

export { render, staticRenderFns }